import React, { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Box, Typography, CircularProgress, TextField } from "@mui/material";
import { apiVariable } from "../../../api/apiVariable";
import useAuth from "../../../hooks/useAuth";
import { rentPaymentTableColumns } from "../../../data/FormColumns/Fleet/rentPaymentTableColumns";
import PersistedDataGrid from "../../PersistedDataGrid/PersistedDataGrid";

const fetchRentPayments = async (token: string | undefined | null) => {
  const { data } = await axios.get(`${apiVariable}/rentPayments`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

const RentPaymentTable: React.FC = () => {
  const { token } = useAuth();

  const [searchTerm, setSearchTerm] = useState("");

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["rentPayments"],
    queryFn: () => fetchRentPayments(token),
    enabled: !!token,
  });

  const filteredRentPayments = useMemo(() => {
    if (!data) return [];
    return data.filter((payment: any) => {
      const dateString = payment.paymentDate
        ? new Date(payment.paymentDate).toLocaleDateString()
        : "";
      return [payment.billToCompanyName, dateString].some((field) =>
        field?.toString().toLowerCase().includes(searchTerm.toLowerCase()),
      );
    });
  }, [data, searchTerm]);

  return (
    <Box className="incidents-table-container" height={900}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <TextField
          label="Search"
          variant="outlined"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by Company or Date"
          sx={{ maxWidth: "100%", width: 400 }}
        />
      </Box>
      {isLoading ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Box>
      ) : isError ? (
        <Typography color="error">Error: {(error as any).message}</Typography>
      ) : (
        <PersistedDataGrid
          tableName="rentPayments"
          rows={filteredRentPayments}
          columns={rentPaymentTableColumns}
          sx={{ height: 700 }}
        />
      )}
    </Box>
  );
};

export default RentPaymentTable;
